import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=398a3b6c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398a3b6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398a3b6c')) {
      api.createRecord('398a3b6c', component.options)
    } else {
      api.reload('398a3b6c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=398a3b6c&scoped=true&", function () {
      api.rerender('398a3b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HKG2OPqc1T14/JS/comp/Accordion.vue"
export default component.exports